import {MultiselectConfig} from '../../../components/multiselect';
import {QueryLangFilterOperator} from '../../../enums/query-lang-filter-operator';
import {QueryLangFilterCriterionMultiselect} from '../../../models/filters/query-lang-filter-criterion-multiselect';
import {TX_HISTORY_REC_METHOD_SELECT_ITEMS} from '../tx-history-rec';

export class FilterTxByMultiMethod extends QueryLangFilterCriterionMultiselect {
    public override name: string = 'filter-tx-by-method';
    public override query: string[] = [];
    public override fieldNames: string[] = ['transaction.type'];
    public override operator: QueryLangFilterOperator = QueryLangFilterOperator.IN;

    public override multiselectConfig: MultiselectConfig = {
        menuItems: TX_HISTORY_REC_METHOD_SELECT_ITEMS,
        label:     'Type' // TODO: locale
    };

    public override getPrimitiveQueryValue(): string {
        return this.query ? this.query.join(',') : '';
    }

}
